import React, { useEffect,  useState } from 'react';
import AuthServices from '../services/AuthServices';
import "../styles/AdminUserReport.css";

function AdminUserReport() {

      const [report, setReport] = useState([]);
    
      useEffect(() => {
        // Charger les données
        const v_key = AuthServices.getConnectedKey();
        fetch(`https://app.listaki.fr/api/WS/getDetailReport.php?key=${v_key}&t=${Date.now()}`, { cache: 'no-store' })
          .then(res => res.json())
          .then(data => setReport(data))
          .catch(err => console.error("Erreur chargement des stats", err));
      }, []);


  return (
    <div className="admin-report">
        <button
          className="back-button"
          onClick={() => (window.location.href = "/")}
        >
          ← Retour à l'application
        </button>

      <h2>Rapport des utilisateurs</h2>

      <table className="admin-table">
        <thead>
          <tr>
            <th>Creation</th>
            <th>Listes</th>
            <th>Objets</th>
            <th>Objets réservés</th>
          </tr>
        </thead>
        <tbody>
          {report.map((row, index) => (
            <tr key={index}>
              <td>
                <a
                  href={`https://app.listaki.fr?key=${row.readonly_key}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {row.dtcreation}
                </a>
              </td>
              <td>{row.nb_lists}</td>
              <td>{row.nb_objects}</td>
              <td>{row.nb_objects_reserved}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AdminUserReport;
